import { render, staticRenderFns } from "./ngo-list.html?vue&type=template&id=1de7d306&scoped=true&external"
import script from "./ngo-list.js?vue&type=script&lang=js&external"
export * from "./ngo-list.js?vue&type=script&lang=js&external"
import style0 from "./ngo-list.scss?vue&type=style&index=0&id=1de7d306&prod&scoped=true&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1de7d306",
  null
  
)

export default component.exports